import { GoogleBusinessConnectionOptions } from '../../../../../modals/live-orders/LiveOrdersDrawer';

export default {
  titles: {
    disable: 'Are you sure you want to disable live orders?',
    enable: 'Are you sure you want to turn ON live orders?',
  },
  form: {
    delivery_app_sales_at_go_live: {
      label: 'Monthly sales on delivery apps',
      description:
        'Total monthly sales across all delivery apps (Lieferando, Wolt, Uber Eats …), as a whole amount. Enter 0 if the restaurant sells on none. After go-live, only an admin can change it.',
      placeholder: 'Enter the monthly amount',
    },
    is_google_business_available: {
      label: 'Google Business available',
    },
    is_smart_pricing_configured: {
      label: 'Cheaper prices than Lieferando, Wolt, Uber',
    },
    is_flyers_package_sent: {
      label: 'Promo Flyer sent',
    },
    is_menu_fully_configured: {
      label: 'All menu items available',
    },
    has_offers_on_competitor_platforms: {
      label: 'Does the restaurant has offers running on Wolt, Uber, Lieferando (except free delivery offer)?',
    },
    is_instagram_story_shared: {
      label: 'Instagram story shared with owner',
    },
    is_order_system_connected_to_website: {
      label: 'Foodamigos Website connected OR Restaurant own Website Online Order button added',
    },
    google_business_connected_by: {
      label: 'How did we gain access to Google Business Profile?',
      options: {
        [GoogleBusinessConnectionOptions.SalesManagerOverEmail]: 'Sales manager invited google@foodamigos.io',
        [GoogleBusinessConnectionOptions.SalesManagerOverPhone]:
          'Sales manager sent the first request themself from the owner Phone',
        [GoogleBusinessConnectionOptions.OnboardingManagerOverEmail]:
          'Onboarding manager requested google business profile (SM did not invite & did not request access)',
      },
    },
  },
  labels: {
    successful_launch:
      'To ensure a successful launch, please review and address the following open points. Verifying \n' +
      'this information will help avoid potential issues once the restaurant is live.',
    check_errors: 'Check the errors to ensure a good launch of the restaurant.',
    checkbox_confirmation:
      'I confirm that I have reviewed the errors and consent to the activation of this restaurant.',
  },
  buttons: {
    check_error: 'Check Error',
    confirm_and_activate: 'Confirm and Activate',
    cancel: 'Cancel',
    yes: 'Yes',
    no: 'No',
  },
  errors: {
    name: {
      title: 'No arabic, chinese etc. characters in shop name',
      description: 'Online shop name includes non english (latin characters)',
    },
    logo_url: {
      title: 'Logo',
      description: 'Logo has been uploaded to online shop',
    },
    pictures: {
      title: 'Gallery image',
      description: '≥ 1 Gallery image is available online shop',
    },
    menu_uploaded: {
      title: 'Menu Uploaded',
      description: '≥ 1 menu is available',
    },
    opening_hours: {
      title: 'Opening hours',
      description: '≥ 1 opening hours added',
    },
    address: {
      title: 'Restaurant address',
      description: 'Street, city, plz entered',
    },
    upsell_items: {
      title: 'Upsell items',
      description: '≥ 3 upsell items have been selected',
    },
    master_promo_code: {
      title: 'Master Promo Code',
      description: 'Master promo code is available',
    },
    flyers_ordered: {
      title: 'Flyers ordered',
      description: '≥ 1 Flyer package ordered',
    },
    test_orders: {
      title: 'Test order sent',
      description: '≥ 1 Test order has been made',
    },
    stripe_billing: {
      title: 'Stripe Account',
      description: 'Stripe account connected',
    },
    payments_configured: {
      title: 'Payments configured',
      description: 'The partner has connected a payment provider — required before going live',
    },
    adyen_merchant_account: {
      title: 'Adyen merchant account',
      description: "An active merchant account for this restaurant's country — required for domestic card rates",
    },
    payment_rail_covers_country: {
      title: 'Payment rail covers the country',
      description: "The partner's payment accounts can process this restaurant's country",
    },
    identity: {
      title: 'Restaurant identity',
      description: 'Restaurant type and cuisine have been set',
    },
    storefront: {
      title: 'Storefront created and domain connected',
      description: 'Only if restaurant wants to use our website',
    },
    google_business: {
      title: 'Google Business',
      description: 'Google Business connected',
    },
    billing_payment_method: {
      title: 'Payment method',
      description: 'Add a payment method so FoodAmigos can bill this restaurant monthly.',
    },
    billing_license: {
      title: 'Licence',
      description: 'This restaurant needs a Partner Plan before it can go live.',
    },
    business_name: {
      title: 'Business / restaurant name',
      description: 'The name shown on the terms of use and privacy policy has been saved',
    },
    payment_method: {
      title: 'Cash or online payments',
      description: 'Cash on pickup or delivery is turned on, or online payments are verified',
    },
    stripe_processing_fee: {
      title: 'Processing fee',
      description: 'The partner has set its Stripe processing fee or confirmed a 0% margin',
    },
  },
};
